import { ChevronLeftOutlineIcon } from '@ikyucom/design-system-icons-react'
import { sva } from '~/styled-system/css'

type HeaderColor = 'white' | 'neutral'

const titleStyles = sva({
  slots: ['header', 'container', 'button', 'icon', 'back', 'title', 'spacer'],
  base: {
    header: {
      zIndex: '20',
      width: 'full',
      borderWidth: 'thin',
      borderColor: 'white',
      borderBottomColor: 'gray.300',
      color: 'gray.800',
      _pc: {
        border: 'none',
      },
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      p: '3',
      lineHeight: 'tight',
      _pc: {
        p: '0',
      },
    },
    button: {
      display: 'flex',
      w: '[56px]',
      alignItems: 'center',
      fill: 'button.secondary.solid',
      _pc: {
        display: 'none',
      },
    },
    back: {
      px: '1',
    },
    icon: {
      w: '[13px]',
      h: '[13px]',
      color: 'gray.500',
    },
    title: {
      flexGrow: '1',
      textAlign: 'center',
      fontSize: 'xl',
      fontWeight: 'bold',
      _pc: {
        textAlign: 'left',
        lineHeight: 'none',
        fontSize: '4xl',
      },
    },
    spacer: {
      w: '[56px]', // previously w-14
    },
  },
  variants: {
    headerColor: {
      white: {
        header: {
          backgroundColor: 'white',
        },
      },
      neutral: {
        header: {
          backgroundColor: 'gray.100',
        },
      },
    },
    layout: {
      full: {
        header: {
          _pc: {
            pt: '8',
            px: '8',
          },
        },
      },
    },
  },
})

export function FusumaTitle({
  title,
  close,
  headerColor = 'white',
  layout,
}: {
  title: string
  close?: () => void
  headerColor?: HeaderColor
  layout?: 'full'
}) {
  const classes = titleStyles({ headerColor, layout })
  return (
    <header className={classes.header}>
      <div className={classes.container}>
        <button type="button" className={classes.button} onClick={close}>
          <ChevronLeftOutlineIcon className={classes.icon} />
          <p className={classes.back}>戻る</p>
        </button>
        <p className={classes.title}>{title}</p>
        <span className={classes.spacer}></span>
      </div>
    </header>
  )
}
